import { useCallback, useMemo, useState, type PropsWithChildren, type SetStateAction } from 'react'
import { DashboardContext, type DashboardContextValue, type DashboardDrawerState } from './dashboardContextCore'

export const DashboardProvider = ({ children }: PropsWithChildren) => {
  const [selectedChecklistNodeId, setSelectedChecklistNodeIdState] = useState<string | null>(null)
  const [drawerState, setDrawerState] = useState<DashboardDrawerState>('CLOSED')
  const setSelectedChecklistNodeId = useCallback((action: SetStateAction<string | null>) => {
    setSelectedChecklistNodeIdState((current) => {
      const next = typeof action === 'function' ? action(current) : action
      setDrawerState(next ? 'NODE_DETAIL' : 'CLOSED')
      return next
    })
  }, [])
  const openChecklistNode = useCallback((nodeId: string) => {
    setSelectedChecklistNodeIdState(nodeId)
    setDrawerState('NODE_DETAIL')
  }, [])
  const closeChecklistNode = useCallback(() => {
    setSelectedChecklistNodeIdState(null)
    setDrawerState('CLOSED')
  }, [])
  const value = useMemo<DashboardContextValue>(() => ({
    selectedChecklistNodeId,
    drawerState,
    setSelectedChecklistNodeId,
    openChecklistNode,
    closeChecklistNode,
  }), [closeChecklistNode, drawerState, openChecklistNode, selectedChecklistNodeId, setSelectedChecklistNodeId])
  return <DashboardContext.Provider value={value}>{children}</DashboardContext.Provider>
}
